module.exports = __webpack_public_path__ + "static/media/loader.3a9024d2.svg";